/**
 * Build / resolve Surveillance rate JSON paths.
 * Bucket hosts come only from `surveillanceConfig` (env-driven).
 */

import {
  SURVEILLANCE_S3_FALLBACK,
  SURVEILLANCE_S3_PRIMARY,
} from './surveillanceConfig'

function trimSlash(url: string): string {
  return url.replace(/\/+$/, '')
}

/** @deprecated prefer SURVEILLANCE_S3_PRIMARY from surveillanceConfig */
export const SURVEILLANCE_RATE_BUCKET_V1 = SURVEILLANCE_S3_PRIMARY
/** @deprecated prefer SURVEILLANCE_S3_FALLBACK from surveillanceConfig */
export const SURVEILLANCE_RATE_BUCKET_V2 = SURVEILLANCE_S3_FALLBACK

/**
 * Lab `moment(marketStartTime).format('DD-MM-YYYY')` — local calendar day
 * (Sportsbook builds `u` with moment, not UTC).
 */
export function formatSurveillanceRateDate(marketStartTime: string | Date): string {
  const d =
    marketStartTime instanceof Date ? marketStartTime : new Date(marketStartTime)
  if (Number.isNaN(d.getTime())) {
    throw new Error('marketStartTime is invalid')
  }
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()
  return `${day}-${month}-${year}`
}

/** Primary rate URL (`runner.u`) — dated v1 bucket. */
export function buildPrimaryRateUrl(input: {
  marketStartTime: string | Date
  marketBetfairId: string
  runnerBetfairId: string
  bucket?: string
}): string {
  const base = trimSlash(input.bucket ?? SURVEILLANCE_S3_PRIMARY)
  const date = formatSurveillanceRateDate(input.marketStartTime)
  const market = input.marketBetfairId.trim()
  const runner = input.runnerBetfairId.trim()
  return `${base}/${date}/${market}/${runner}.json`
}

/** Fallback rate URL (`runner.fu`) — v2 bucket. */
export function buildFallbackRateUrl(input: {
  eventTypeBetfairId: string
  marketBetfairId: string
  runnerBetfairId: string
  bucket?: string
}): string {
  const base = trimSlash(input.bucket ?? SURVEILLANCE_S3_FALLBACK)
  const eventType = input.eventTypeBetfairId.trim()
  const market = input.marketBetfairId.trim()
  const runner = input.runnerBetfairId.trim()
  return `${base}/${eventType}/${market}/${runner}.json`
}

/**
 * If the API returns a full https URL, keep it (server already chose domain).
 * If it returns a key/path, attach the configured bucket.
 */
export function resolveRateUrl(
  raw: string,
  kind: 'primary' | 'fallback',
): string {
  const t = raw.trim()
  if (!t) return t
  if (/^https?:\/\//i.test(t)) return t
  if (t.startsWith('static://')) return t
  const path = t.replace(/^\/+/, '')
  const base = kind === 'primary' ? SURVEILLANCE_S3_PRIMARY : SURVEILLANCE_S3_FALLBACK
  return `${base}/${path}`
}
